// popups
$('.popup .close-popup').click(function () {
    $(this).closest('.popup').removeClass('open');
});

$('.popup').click(function (event) {
    if (event.target === this) {
        $(this).removeClass('open');
    }
});

if(window.location.hash){
    var $target  = $(window.location.hash)
    var header_height = $('header').height()
    if($target.length > 0) {
        $('html, body').animate({scrollTop: $target.offset().top - header_height - 50 } , 400);
    }
}

$(document).on('click', 'a[href*="#"]', function(e) {
    var href = $(this).attr("href");
    if( ( href.startsWith("#") || href.startsWith(window.location.href + "#") ) && href !== '#' ) {
        e.preventDefault();
        var target = href.split("#")[1]
        if( target == 'scroll-to-page-top') {
            //scroll-to-page-top
            $('html, body').animate({scrollTop: $('html, body').offset().top } , 1000);
        } else if( target.startsWith('open-popup')) {
            $('.popup[id=' + target + ']').addClass('open');
        } else {
            if( $('#' + target).length > 0 ) {
                var header_height = $('header').height()
                $('html, body').animate({scrollTop: $('#' + target).offset().top - header_height - 50 } , 400);
            }
        }
    }
})

